import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AppTheme, themeModes } from "../../shared/theme";
import { useSidebarDarkMode } from "../../layouts/app/useAppLayoutAppearance";
import SessionBootstrap from "../bootstrap/SessionBootstrap";
import { AuthProvider } from "./AuthProvider";

function ThemedAppContent({ children }) {
  const sidebarDark = useSidebarDarkMode();

  return (
    <AppTheme mode={sidebarDark ? themeModes.dark : themeModes.light}>
      <Toaster
        reverseOrder
        toastOptions={{
          position: "bottom-left",
          style: { maxWidth: "100vw" },
          duration: 5000,
        }}
      />
      {children}
    </AppTheme>
  );
}

export default function AppProviders({ children }) {
  return (
    <BrowserRouter future={{ v7_startTransition: true }}>
      <AuthProvider>
        <SessionBootstrap>
          <ThemedAppContent>{children}</ThemedAppContent>
        </SessionBootstrap>
      </AuthProvider>
    </BrowserRouter>
  );
}
